import InsomniaSurvey from 'screens/InsomniaSurvey/InsomniaSurvey';
import osaSurveyConfig from 'surveys/osa_funnel/survey/osa_funnel';
import {OsaPaywall} from 'surveys/osa_funnel/paywall/OsaPaywall';
import {OsaPaywallConfirm} from 'surveys/osa_funnel/paywall/OsaPaywallConfirm';
import {Glp1MedicalScreening} from 'surveys/osa_funnel/screening/Glp1MedicalScreening';

export const useOsaSurveyConfig = () => {
  return osaSurveyConfig;
};

export const OsaSurveyScreenContainer = () => {
  const surveyConfig = useOsaSurveyConfig();
  return <InsomniaSurvey surveyConfigJson={surveyConfig} />;
};

export const OsaCheckoutScreenContainer = () => {
  return <OsaPaywall />;
};

export const OsaCheckoutConfirmScreenContainer = () => {
  return <OsaPaywallConfirm />;
};

export const OsaScreeningScreenContainer = () => {
  return <Glp1MedicalScreening />;
};
